import { render } from "./OmniSearchIconOnly.vue?vue&type=template&id=3c1d13db&scoped=true&ts=true"
import script from "./OmniSearchIconOnly.ts?vue&type=script&lang=ts"
export * from "./OmniSearchIconOnly.ts?vue&type=script&lang=ts"

import "./OmniSearchIconOnly.scss?vue&type=style&index=0&id=3c1d13db&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src397822955/src/codestar-connections.eu-west-1.amazonaws.com/git-http/637423592620/eu-west-1/d1c24b47-9e0d-4a51-af9e-d1114251523b/studyportals/WishlistButton/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c1d13db"]])

export default __exports__